import React from 'react';
import _ from 'lodash';
import ScheduledTaskBasicInfoComponent from './scheduled-tasks-basic-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';

export const ScheduleTaskComponent = ({
  handleInnerFormChange,
  handleFormSubmit,
  handleFormItemChange,
  deleteSelectedService,
  scheduleCommands,
  id,
  scheduledTask,
  handleInnerBasicFormChange,
  back
}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Schedule Task Information',
        component: <ScheduledTaskBasicInfoComponent
        scheduledTasks={scheduledTask}
        handleInnerFormChange={handleInnerFormChange}
        handleFormItemChange = {handleFormItemChange}
        deleteSelectedService = {deleteSelectedService}
        scheduleCommands={scheduleCommands}
        handleInnerBasicFormChange={handleInnerBasicFormChange}
        id ={id}
      />,
    isVisible:true,
    }
  ]
  return (
    <>
      
      <TabContainer tabItems={tabItems} />
         
          <div className="text-end">
          <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={back}
            
              type="submit"
          >
            Back
          </button>
          <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
         
          </div>
      
    </>
  );
};
export default ScheduleTaskComponent;
